import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d85d17aa"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["innerHTML"]

import { useFormErrorMessageHandler } from '@/utils/form';
import { useQueryClient } from 'vue-query';
import { PropType, reactive, ref, computed, inject, watch } from 'vue';
import { required } from '@vuelidate/validators';

import { useGetDeviceQuery, useGetNestedDevicesQuery } from '@/entities/device/hooks';
import { createInspection } from '@/entities/inspection/services';
// import { useGetWeathersQuery } from '@/entities/weather/hooks';
import { getInspectionGroup } from '@/entities/inspection-group/services';

import { FormatDateInjection } from '@/plugins/date-fns';
import { Device } from '@/entities/device/types';
import {
  CreateInspectionGroupData,
  CreateInspectionGroupFields
} from '@/entities/inspection-group/types';

import { useForm } from '@/core/hooks/forms';
import { useGetCurrentUserQuery } from '@/entities/user/hooks';
import { useGetServicesQuery } from '@/entities/services/hooks';
import {
  inspectionGroupsQueryName,
  useCreateInspectionGroupMutation,
} from '@/entities/inspection-group/hooks';

import {
  NkButton,
  NkCheckbox,
  NkCol,
  NkDatePicker,
  NkForm,
  NkFormItem,
  NkGrid,
  NkGroup,
  NkOption,
  NkSelect,
  NkTextArea,
} from '@/core/components';
import { ASSEMBLY_MODE, AVAILABLE_MODE } from '@/entities/inspection-group/common';


export default /*#__PURE__*/_defineComponent({
  __name: 'InspectionGroupCreateForm',
  props: {
  device: {
    type: Number as PropType<Device['id']>,
    default: null,
    required: true,
  },
},
  emits: [],
  setup(__props, { emit }) {

const props = __props


const { onSubmitted } = useForm(emit);



const cascaderProps = {
  multiple: true,
};

const $format: FormatDateInjection = inject('$format') as FormatDateInjection;

// TODO: REMOVE WHEN NEW SOLUTION IS DECIDED BY SUPAIRVISION
const deviceQueryData = computed(() => ({ id: props.device }));
const hasDeviceQueryData = computed(() => !!deviceQueryData.value.id);
const { data: nestedDevicesData } = useGetNestedDevicesQuery(deviceQueryData, { enabled: hasDeviceQueryData });
const nestedDevices = computed(() => nestedDevicesData.value?.filter(o => [1, 3, 4, 5, 6, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23].includes(o.type)));
const { data: rootDevice } = useGetDeviceQuery(deviceQueryData);

const queryClient = useQueryClient();

const { data: currentUser } = useGetCurrentUserQuery();
const servicesQueryFilters = computed(() => ({
  'order[name]': 'asc'
}))
const { data: services } = useGetServicesQuery({}, servicesQueryFilters);

const availableServices = computed(() =>
  services.value?.filter((service) => ![9,10,12,14,16,18].includes(service.id))
);

const form = ref();
const isCreatingInspectionForEachDevices = ref(false);

const handleChange = (value) => {
  console.log('o', value);
}

const statuses = ref([
  {
    id: 1,
    label: 'To do',
    value: 'to do',
  },
  {
    id: 2,
    label: 'Doing',
    value: 'doing',
  },
  {
    id: 3,
    label: 'Done',
    value: 'done',
  },
]);

const fields: CreateInspectionGroupFields = reactive({
  date: $format(new Date(), 'yyyy-MM-dd'),
  user: currentUser.value?.id,
  device: props.device,
  comment: '',
  service: null,
  status: 'to do',
  weather: null,
  inspectedBySupairvision: false,
  devices: [],
  isCertified: false,
  mode: ASSEMBLY_MODE
});

const rules = {
  service: {
    required,
  },
  date: {
    required,
  },
  status: {
    required,
  },
};

const {
  mutateAsync,
  isLoading: inspectionGroupIsLoading,
  isError,
  error: createInspectionGroupError,
} = useCreateInspectionGroupMutation();

const nodeList = computed(() => {
  if (!rootDevice.value) {
    return [];
  }

  const root = { value: props.device, label: rootDevice.value.deviceValues.find(o => o.reference === 'name')?.value || '-', children: [] }
  const _ = {} as any;
  _[props.device] = root;
  nestedDevicesData.value?.forEach(node => {
    const serviceDeviceTypes = fields.service !== null ? services.value?.find(s => s.id === fields.service)?.deviceTypes : [];

    if (serviceDeviceTypes.includes(node.type) || serviceDeviceTypes.length === 0) {
      // add devices linked to the service
        _[node.id] = {
          value: node.id,
          label: node.deviceValues.find(o => o.reference === 'name')?.value || '-',
          children: []
        }

        if (fields.service === 2 && (_[node.id].label.toLowerCase() === 'le' || _[node.id].label.toLowerCase() === 'te')) {
          _[node.id].disabled = true
        }

        _[node.parent as number].children.push(_[node.id]);
    } else {
      // clear the devices not linked to the service
      fields.devices = fields.devices.filter((d: number[]) => !d.includes(node.id));
    }
  })

  return [root];
})

const { error } = useFormErrorMessageHandler(createInspectionGroupError);

const creationIsLoading = computed(() => inspectionGroupIsLoading.value || isCreatingInspectionForEachDevices.value)

const submit = () => {
  if (!creationIsLoading.value) {
    form.value.validator.$validate().then((valid: boolean) => {
      if (valid) {
        const {isCertified} = fields;

        if (isCertified && fields.service === 1) {
          fields.service = 9;
        } else if (isCertified && fields.service === 6) {
          fields.service = 10;
        } else if (isCertified && fields.service === 11) {
          fields.service = 12;
        } else if (isCertified && fields.service === 13) {
          fields.service = 14;
        } else if (isCertified && fields.service === 15) {
          fields.service = 16;
        } else if (isCertified && fields.service === 17) {
          fields.service = 18;
        }

        mutateAsync(
          fields,
        ).then(async (data) => {
          const flatDevices = fields.devices.flat()
          if (nestedDevices.value?.length) {
            isCreatingInspectionForEachDevices.value = true;
            let d = nestedDevices.value
            if (flatDevices.length !== 0) {
              d = d?.filter(v => flatDevices.includes(v.id))
            }

            await Promise.all(d?.map(o => createInspection({
                inspectionGroup: data.id,
                date: data.date,
                status: data.status,
                device: o.id,
              }),
            )).then(() => {
              queryClient.refetchQueries([inspectionGroupsQueryName, { id: data.id }], { active: true }).then(() => {
                getInspectionGroup({ id: data.id }).then((res) => {
                  onSubmitted(res);
                }).catch(() => {
                  onSubmitted(data);
                }).finally(() => {
                  isCreatingInspectionForEachDevices.value = false;
                });
              });
            });
          } else {
            onSubmitted(data);
          }
        });
      }
    });
  }
};

watch(
  () => fields.service,
  () => {
    const selectedDevice: number[][] = [];
    const list = nodeList.value[0];

    /**
     * We need to check every component of the wind turbine and retrieve his value.
     * The select component need an array with 3 values (one for each column) to be validated
     */
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < list.children.length; i++) {
      const children : { value: number,  children: [] } = list.children[i];
      const device = children.children.filter(element => !element.disabled );

      device.forEach(( element ) => {
        selectedDevice.push([nodeList.value[0].value, children.value, element.value]);
      });
    }

    fields.devices = selectedDevice;
});


return (_ctx: any,_cache: any) => {
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_ElCascader = _resolveComponent("ElCascader")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createBlock(_unref(NkForm), {
    ref_key: "form",
    ref: form,
    fields: fields,
    rules: rules
  }, {
    footer: _withCtx(() => [
      _createVNode(_unref(NkGroup), { position: "right" }, {
        default: _withCtx(() => [
          _createVNode(_unref(NkButton), {
            disabled: _unref(creationIsLoading),
            type: "success",
            onClick: submit
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('actions.create')), 1)
            ]),
            _: 1
          }, 8, ["disabled"])
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      (_unref(isError))
        ? (_openBlock(), _createBlock(_component_el_alert, {
            key: 0,
            type: "error",
            title: _unref(error)
          }, null, 8, ["title"]))
        : _createCommentVNode("", true),
      _createVNode(_unref(NkGrid), null, {
        default: _withCtx(() => [
          _createVNode(_unref(NkCol), { span: 6 }, {
            default: _withCtx(() => [
              _createVNode(_unref(NkFormItem), {
                prop: "service",
                label: _ctx.$t('inspection-group.form.field.service.label')
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(NkSelect), {
                    modelValue: fields.service,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((fields.service) = $event))
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(availableServices), (service) => {
                        return (_openBlock(), _createBlock(_unref(NkOption), {
                          key: service.id,
                          value: service.id,
                          label: service.name
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(NkGroup), null, {
                              default: _withCtx(() => [
                                _createElementVNode("span", {
                                  class: "inspection-group-create__select__option",
                                  innerHTML: service.svg
                                }, null, 8, _hoisted_1),
                                _createTextVNode(" " + _toDisplayString(service.name), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1032, ["value", "label"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"])
            ]),
            _: 1
          }),
          _createVNode(_unref(NkCol), { span: 6 }, {
            default: _withCtx(() => [
              _createVNode(_unref(NkFormItem), {
                prop: "date",
                label: _ctx.$t('inspection-group.form.field.date.label')
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(NkDatePicker), {
                    modelValue: fields.date,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((fields.date) = $event)),
                    "value-format": "YYYY-MM-DD",
                    onChange: handleChange
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(NkFormItem), {
        prop: "devices",
        label: _ctx.$t('misc.device')
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ElCascader, {
            modelValue: fields.devices,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((fields.devices) = $event)),
            clearable: "",
            "collapse-tags-tooltip": "",
            "show-all-levels": false,
            props: cascaderProps,
            options: _unref(nodeList)
          }, null, 8, ["modelValue", "options"])
        ]),
        _: 1
      }, 8, ["label"]),
      (![1,6,11,13,15,17].includes(fields.service))
        ? (_openBlock(), _createBlock(_unref(NkFormItem), {
            key: 1,
            prop: "service",
            label: _ctx.$t('inspection-group.form.field.mode.label')
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(NkSelect), {
                modelValue: fields.mode,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((fields.mode) = $event))
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(AVAILABLE_MODE), (mode) => {
                    return (_openBlock(), _createBlock(_unref(NkOption), {
                      key: mode.value,
                      value: mode.value,
                      label: mode.label
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(NkGroup), null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(mode.label), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1032, ["value", "label"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"]))
        : _createCommentVNode("", true),
      _createVNode(_unref(NkFormItem), {
        prop: "comment",
        label: _ctx.$t('inspection-group.form.field.comment.label')
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(NkTextArea), {
            modelValue: fields.comment,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((fields.comment) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }, 8, ["label"]),
      (_ctx.$store.getters['connection/isGranted'](['ROLE_ADMIN']))
        ? (_openBlock(), _createBlock(_unref(NkFormItem), {
            key: 2,
            prop: "inspectedBySupairvision"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(NkCheckbox), {
                modelValue: fields.inspectedBySupairvision,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((fields.inspectedBySupairvision) = $event))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('inspection-group.form.field.inspectionBySupairvision.label')), 1)
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.$store.getters['connection/isGranted'](['ROLE_ADMIN']) && ([1,6,11,13,15,17].includes(fields.service)))
        ? (_openBlock(), _createBlock(_unref(NkFormItem), {
            key: 3,
            prop: "isCertified"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(NkCheckbox), {
                modelValue: fields.isCertified,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((fields.isCertified) = $event))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('inspection-group.form.field.certified.label')), 1)
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["fields"])), [
    [_directive_loading, _unref(creationIsLoading)]
  ])
}
}

})